"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: ledger/fee-context.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fledger%2Ffee-context.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.lendingReactivationContextReasonToJSON = exports.lendingReactivationContextReasonFromJSON = exports.TaxContext = exports.LendingReactivationContext = exports.NewCardContext = exports.CardReplacementContext = exports.TestFeeContext = exports.OverdraftProtectionReactivationContext = exports.BnplReactivationContext = exports.FeeContext = exports.LendingReactivationContextReason = void 0;
const address_1 = require("../common/address");
const protobufPackage = 'com.step.common.fee.proto';
var LendingReactivationContextReason;
(function (LendingReactivationContextReason) {
    LendingReactivationContextReason["INVALID_REACTIVATION_REASON"] = "INVALID_REACTIVATION_REASON";
    LendingReactivationContextReason["OVERDRAFT_DELINQUENCY"] = "OVERDRAFT_DELINQUENCY";
    LendingReactivationContextReason["BNPL_DELINQUENCY"] = "BNPL_DELINQUENCY";
    LendingReactivationContextReason["UNRECOGNIZED"] = "UNRECOGNIZED";
})(LendingReactivationContextReason || (exports.LendingReactivationContextReason = LendingReactivationContextReason = {}));
function createBaseFeeContext() {
    return {
        bnplReactivation: undefined,
        overdraftProtectionReactivation: undefined,
        cardReplacement: undefined,
        lendingReactivation: undefined,
        newCard: undefined,
        test: undefined,
    };
}
exports.FeeContext = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.bnplReactivation)) {
            message.bnplReactivation = exports.BnplReactivationContext.fromJSON(object.bnplReactivation);
        }
        if (isSet(object.overdraftProtectionReactivation)) {
            message.overdraftProtectionReactivation = exports.OverdraftProtectionReactivationContext.fromJSON(object.overdraftProtectionReactivation);
        }
        if (isSet(object.cardReplacement)) {
            message.cardReplacement = exports.CardReplacementContext.fromJSON(object.cardReplacement);
        }
        if (isSet(object.lendingReactivation)) {
            message.lendingReactivation = exports.LendingReactivationContext.fromJSON(object.lendingReactivation);
        }
        if (isSet(object.newCard)) {
            message.newCard = exports.NewCardContext.fromJSON(object.newCard);
        }
        if (isSet(object.test)) {
            message.test = exports.TestFeeContext.fromJSON(object.test);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.bnplReactivation !== undefined) {
            obj.bnplReactivation = exports.BnplReactivationContext.toJSON(message.bnplReactivation);
        }
        if (message.overdraftProtectionReactivation !== undefined) {
            obj.overdraftProtectionReactivation = exports.OverdraftProtectionReactivationContext.toJSON(message.overdraftProtectionReactivation);
        }
        if (message.cardReplacement !== undefined) {
            obj.cardReplacement = exports.CardReplacementContext.toJSON(message.cardReplacement);
        }
        if (message.lendingReactivation !== undefined) {
            obj.lendingReactivation = exports.LendingReactivationContext.toJSON(message.lendingReactivation);
        }
        if (message.newCard !== undefined) {
            obj.newCard = exports.NewCardContext.toJSON(message.newCard);
        }
        if (message.test !== undefined) {
            obj.test = exports.TestFeeContext.toJSON(message.test);
        }
        return obj;
    },
    create(base) {
        return exports.FeeContext.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFeeContext();
        message.bnplReactivation =
            (object.bnplReactivation !== undefined && object.bnplReactivation !== null)
                ? exports.BnplReactivationContext.fromPartial(object.bnplReactivation)
                : undefined;
        message.overdraftProtectionReactivation =
            (object.overdraftProtectionReactivation !== undefined &&
                object.overdraftProtectionReactivation !== null)
                ? exports.OverdraftProtectionReactivationContext.fromPartial(object.overdraftProtectionReactivation)
                : undefined;
        message.cardReplacement =
            (object.cardReplacement !== undefined && object.cardReplacement !== null)
                ? exports.CardReplacementContext.fromPartial(object.cardReplacement)
                : undefined;
        message.lendingReactivation =
            (object.lendingReactivation !== undefined && object.lendingReactivation !== null)
                ? exports.LendingReactivationContext.fromPartial(object.lendingReactivation)
                : undefined;
        message.newCard = (object.newCard !== undefined && object.newCard !== null)
            ? exports.NewCardContext.fromPartial(object.newCard)
            : undefined;
        message.test = (object.test !== undefined && object.test !== null)
            ? exports.TestFeeContext.fromPartial(object.test)
            : undefined;
        return message;
    },
};
function createBaseBnplReactivationContext() {
    return {};
}
exports.BnplReactivationContext = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.BnplReactivationContext.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseBnplReactivationContext();
        return message;
    },
};
function createBaseOverdraftProtectionReactivationContext() {
    return {};
}
exports.OverdraftProtectionReactivationContext = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.OverdraftProtectionReactivationContext.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseOverdraftProtectionReactivationContext();
        return message;
    },
};
function createBaseTestFeeContext() {
    return {};
}
exports.TestFeeContext = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.TestFeeContext.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseTestFeeContext();
        return message;
    },
};
function createBaseCardReplacementContext() {
    return { cardId: '', quotaLimit: '0', isMetal: undefined, taxContext: undefined };
}
exports.CardReplacementContext = {
    fromJSON(object) {
        const message = {
            cardId: isSet(object.cardId) ? globalThis.String(object.cardId) : '',
        };
        if (isSet(object.quotaLimit)) {
            message.quotaLimit = globalThis.String(object.quotaLimit);
        }
        if (isSet(object.isMetal)) {
            message.isMetal = globalThis.Boolean(object.isMetal);
        }
        if (isSet(object.taxContext)) {
            message.taxContext = exports.TaxContext.fromJSON(object.taxContext);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cardId !== '') {
            obj.cardId = message.cardId;
        }
        if (message.quotaLimit !== undefined && message.quotaLimit !== '0') {
            obj.quotaLimit = message.quotaLimit;
        }
        if (message.isMetal !== undefined) {
            obj.isMetal = message.isMetal;
        }
        if (message.taxContext !== undefined) {
            obj.taxContext = exports.TaxContext.toJSON(message.taxContext);
        }
        return obj;
    },
    create(base) {
        return exports.CardReplacementContext.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCardReplacementContext();
        message.cardId = object.cardId ?? '';
        message.quotaLimit = object.quotaLimit ?? '0';
        message.isMetal = object.isMetal ?? undefined;
        message.taxContext = (object.taxContext !== undefined && object.taxContext !== null)
            ? exports.TaxContext.fromPartial(object.taxContext)
            : undefined;
        return message;
    },
};
function createBaseNewCardContext() {
    return { isMetal: undefined, taxContext: undefined };
}
exports.NewCardContext = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.isMetal)) {
            message.isMetal = globalThis.Boolean(object.isMetal);
        }
        if (isSet(object.taxContext)) {
            message.taxContext = exports.TaxContext.fromJSON(object.taxContext);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.isMetal !== undefined) {
            obj.isMetal = message.isMetal;
        }
        if (message.taxContext !== undefined) {
            obj.taxContext = exports.TaxContext.toJSON(message.taxContext);
        }
        return obj;
    },
    create(base) {
        return exports.NewCardContext.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseNewCardContext();
        message.isMetal = object.isMetal ?? undefined;
        message.taxContext = (object.taxContext !== undefined && object.taxContext !== null)
            ? exports.TaxContext.fromPartial(object.taxContext)
            : undefined;
        return message;
    },
};
function createBaseLendingReactivationContext() {
    return { reason: LendingReactivationContextReason.INVALID_REACTIVATION_REASON };
}
exports.LendingReactivationContext = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.reason)) {
            message.reason = lendingReactivationContextReasonFromJSON(object.reason);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.reason !== undefined &&
            message.reason !== LendingReactivationContextReason.INVALID_REACTIVATION_REASON) {
            obj.reason = lendingReactivationContextReasonToJSON(message.reason);
        }
        return obj;
    },
    create(base) {
        return exports.LendingReactivationContext.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLendingReactivationContext();
        message.reason = object.reason ?? LendingReactivationContextReason.INVALID_REACTIVATION_REASON;
        return message;
    },
};
function createBaseTaxContext() {
    return { address: address_1.Address.fromPartial({}), calculationId: '' };
}
exports.TaxContext = {
    fromJSON(object) {
        const message = {
            address: isSet(object.address) ? address_1.Address.fromJSON(object.address) : address_1.Address.fromPartial({}),
        };
        if (isSet(object.calculationId)) {
            message.calculationId = globalThis.String(object.calculationId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.address !== undefined) {
            obj.address = address_1.Address.toJSON(message.address);
        }
        if (message.calculationId !== undefined && message.calculationId !== '') {
            obj.calculationId = message.calculationId;
        }
        return obj;
    },
    create(base) {
        return exports.TaxContext.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTaxContext();
        message.address = (object.address !== undefined && object.address !== null)
            ? address_1.Address.fromPartial(object.address)
            : address_1.Address.fromPartial({});
        message.calculationId = object.calculationId ?? '';
        return message;
    },
};
function lendingReactivationContextReasonFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_REACTIVATION_REASON':
            return LendingReactivationContextReason.INVALID_REACTIVATION_REASON;
        case 1:
        case 'OVERDRAFT_DELINQUENCY':
            return LendingReactivationContextReason.OVERDRAFT_DELINQUENCY;
        case 2:
        case 'BNPL_DELINQUENCY':
            return LendingReactivationContextReason.BNPL_DELINQUENCY;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return LendingReactivationContextReason.UNRECOGNIZED;
    }
}
exports.lendingReactivationContextReasonFromJSON = lendingReactivationContextReasonFromJSON;
function lendingReactivationContextReasonToJSON(object) {
    switch (object) {
        case LendingReactivationContextReason.INVALID_REACTIVATION_REASON:
            return 'INVALID_REACTIVATION_REASON';
        case LendingReactivationContextReason.OVERDRAFT_DELINQUENCY:
            return 'OVERDRAFT_DELINQUENCY';
        case LendingReactivationContextReason.BNPL_DELINQUENCY:
            return 'BNPL_DELINQUENCY';
        case LendingReactivationContextReason.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.lendingReactivationContextReasonToJSON = lendingReactivationContextReasonToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=fee-context.js.map